import { ApiQuery, ApiService } from "@/domain/clients";
import { BlogPostListMeta } from "@/domain/entities";
import { Endpoints } from "@/infra/api";
import { BlogPostResponse } from "@/data/dtos/responses";
import { BlogPostDataSource } from "./BlogPostDataSource";

export class BlogPostRemoteDataSource implements BlogPostDataSource {
  constructor(private readonly api: ApiService) {}

  async getPosts(
    query?: ApiQuery,
  ): Promise<{ data: BlogPostResponse[]; meta?: BlogPostListMeta }> {
    const response = await this.api.get<BlogPostResponse[]>(
      Endpoints.blog_posts,
      query,
    );

    return { data: response.data ?? [], meta: response.meta };
  }
}
